// extracted by mini-css-extract-plugin
export var body = "_nr-8";
export var button = "_nr-0";
export var closeButton = "_nr-5";
export var content = "_nr-3";
export var empty = "_nr-f";
export var grid = "_nr-c";
export var header = "_nr-4";
export var icon = "_nr-1";
export var option = "_nr-d";
export var optionSelected = "_nr-e";
export var overlay = "_nr-2";
export var searchIcon = "_nr-a";
export var searchInput = "_nr-b";
export var searchWrapper = "_nr-9";
export var title = "_nr-6";
export var visuallyHidden = "_nr-7";